"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiData_1 = __importDefault(require("@/api/class/ApiData"));
const systemApi = {
    serviceProviderList: new ApiData_1.default({
        name: '服务商列表',
        url: 'web/cs-service/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    serviceProviderBuild: new ApiData_1.default({
        name: '服务商新增',
        url: 'web/cs-service/create',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    serviceProviderChange: new ApiData_1.default({
        name: '服务商编辑',
        url: 'web/cs-service/modify',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    serviceProviderDelete: new ApiData_1.default({
        name: '服务商删除',
        url: 'web/cs-service/deletes',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    parkingPointList: new ApiData_1.default({
        name: '停车点列表',
        url: 'web/cs-park-point/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    parkingPointBuild: new ApiData_1.default({
        name: '停车点新增',
        url: 'web/cs-park-point/create',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    parkingPointChange: new ApiData_1.default({
        name: '停车点编辑',
        url: 'web/cs-park-point/modify',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    parkingPointDelete: new ApiData_1.default({
        name: '停车点删除',
        url: 'web/cs-park-point/deletes',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    assignRuleList: new ApiData_1.default({
        name: '分派规则列表',
        url: 'web/cs-assign-rule/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    assignRuleBuild: new ApiData_1.default({
        name: '分派规则新增',
        url: 'web/cs-assign-rule/create',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    assignRuleChange: new ApiData_1.default({
        name: '分派规则编辑',
        url: 'web/cs-assign-rule/modify',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    assignRuleDelete: new ApiData_1.default({
        name: '分派规则删除',
        url: 'web/cs-assign-rule/deletes',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    areaList: new ApiData_1.default({
        name: '区域列表',
        url: 'web/csAssignRuleArea/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    areaBuild: new ApiData_1.default({
        name: '区域新增',
        url: 'web/csAssignRuleArea/create',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    areaChange: new ApiData_1.default({
        name: '区域编辑',
        url: 'web/csAssignRuleArea/modify',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    areaDelete: new ApiData_1.default({
        name: '区域删除',
        url: 'web/csAssignRuleArea/deletes',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    operateLogList: new ApiData_1.default({
        name: '日志列表',
        url: 'web/cs-sys-log/page',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    operateLogBuild: new ApiData_1.default({
        name: '日志新增',
        url: 'web/cs-sys-log/save',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
};
exports.default = systemApi;
